

import React, { useState } from 'react';
import TextInput from '../components/basicComponents/text-input';
import ImageUpload from '../components/basicComponents/image-upload';
import Container from '../components/basicComponents/container';
import * as Icons from "../assets/SVGs/index";
import Button from '../components/basicComponents/button'; // Import the Button component

interface FormData {
  title: string;
  image: File | null;
  content: string; // Change from EditorState to string
}

export default function WebsiteInformation() {
  const [formData, setFormData] = useState<FormData>({
    title: '',
    image: null,
    content: '', // Initialize content as an empty string
  });

  const handleTitleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, title: e.target.value });
  };

  const handleImageChange = (file: File | null) => {
    if (file) {
      console.log("Uploaded file:", file);
      setFormData({ ...formData, image: file }); // Update image state
    }
  };


  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    // Logic to handle form submission, e.g., sending data to an API
  };

  return (
    <div className="flex flex-col items-center w-full">
      <Container header="اطلاعات وبسایت">
        <form onSubmit={handleSubmit} className="w-full">
          {/* Title input using TextInput component */}
          <div className="mb-5 mt-5 md:w-[25%] w-full">
            <TextInput
          
              name="title"
              value={formData.title}
              placeholder="نام شرکت"
              onChange={handleTitleChange}
              label="نام شرکت"
              RightIcon={<Icons.UserGroupIcon className='w-5 h-5' />}
            />
          </div>



<div className='md:w-[25%] w-full'>
          {/* Image upload section */}
          <ImageUpload 
  onImageChange={handleImageChange} 
  storageKey="webImageBase64" // Unique key for About page
/>

</div>
 

          <div className='flex justify-end'>
            {/* Submit button */}
            <Button
              type="submit"
              title="ثبت"
              variant="success" 
              bgColor='#9EE1D1'
              borderColor='#00B087'
              color='#00B087'
            />
          </div>
        </form>
      </Container>
    </div>
  );
}
